import axiosIns from 'utils/axios'
let epmcore = 'EPM-CORE-SERVICE'

// 查询项目角色
export function getProjectRoleByProjectId (params) {
  return axiosIns({
    url: `/api/pc/projectRole/page`,
    owner: epmcore,
    method: 'get',
    params
  })
}

// 更新项目角色
export function updateProjectRole (data) {
  return axiosIns({
    url: `/api/pc/projectRole/update`,
    owner: epmcore,
    method: 'put',
    data
  })
}
// 新增项目角色
export function addProjectRole (data) {
  return axiosIns({
    url: `/api/pc/projectRole/add`,
    owner: epmcore,
    method: 'post',
    data: data
  })
}
// 删除项目角色
export function removeProjectRoleById (id) {
  return axiosIns({
    url: `/api/pc/projectRole/${id}`,
    owner: epmcore,
    method: 'delete'
  })
}


// -------------------------------------


// 查询项目成员
export function getProjectMemberByProPjectId (data) {
  return axiosIns({
    url: `/api/pc/projectMember/page`,
    owner: epmcore,
    method: 'get',
    params: data
  })
}

// 更新项目成员
export function updateProjectMember (data) {
  return axiosIns({
    url: `/api/pc/projectMember/update`,
    owner: epmcore,
    method: 'put',
    data: data
  })
}
// 新增项目成员
export function addProjectMember (data) {
  return axiosIns({
    url: `/api/pc/projectMember/add`,
    owner: epmcore,
    method: 'post',
    data: data
  })
}
// 删除项目成员
export function removeProjectMemberById (id) {
  return axiosIns({
    url: `/api/pc/projectMember/${id}`,
    owner: epmcore,
    method: 'delete'
  })
}
// ----

//获取整棵树包括人员
export function getTreeAndPerson () {
  return axiosIns({
    url: `/api/pc/organization/listDetail`,
    method: 'get',
    owner: epmcore
  })
}

export function formatTreeAndPerson (e, parentid) {
  let tree = []
  e.forEach((item) => {
    if (!item.mpttVOList && !item.data.employeeVOList) {
      tree.push({
        label: item.data.name,
        key: item.id + '-' + parentid + '-' + isDepartment(item) || item.data.id + '-' + parentid + '-' + isDepartment(item),
        rootId: item.rootId,
        companyId: item.data.companyId,
        mpttRootId: item.data.mpttRootId,
        principal: item.data.principal,
        children: [],
        disabled: checkDisabled(item)
      })
    } else if (item.mpttVOList && !item.data.employeeVOList) {
      tree.push({
        label: item.data.name,
        key: item.id + '-' + parentid + '-' + isDepartment(item) || item.data.id + '-' + parentid + '-' + isDepartment(item),
        rootId: item.rootId,
        companyId: item.data.companyId,
        mpttRootId: item.data.mpttRootId,
        principal: item.data.principal,
        children: formatTreeAndPerson(item.mpttVOList, item.id),
        disabled: checkDisabled(item)
      })
    } else if (!item.mpttVOList && item.data.employeeVOList) {
      tree.push({
        label: item.data.name,
        key: item.data.id + '-' + parentid + '-' + isDepartment(item),
        rootId: item.rootId,
        companyId: item.data.companyId,
        mpttRootId: item.data.mpttRootId,
        principal: item.data.principal,
        children: formatChildren(item.data.employeeVOList, item.data.id),
        disabled: checkDisabled(item)
      })
    } else if (item.mpttVOList && item.data.employeeVOList) {
      tree.push({
        label: item.data.name,
        key: item.id,
        rootId: item.rootId,
        companyId: item.data.companyId,
        mpttRootId: item.data.mpttRootId,
        principal: item.data.principal,
        children: formatTreeAndPerson(item.mpttVOList, item.id).concat(formatChildren(item.data.employeeVOList, item.data.id)),
        disabled: checkDisabled(item)
      })
    }
  })
  return tree
}

function checkDisabled (e) {
  // if (e) return true
  // else return false
  return false
}

function isDepartment (e) {
  if (e) return 1
  else return 0
}

function formatChildren (e, parentid) {
  let tree = []
  e.forEach(item => {
    tree.push(Object.assign(item, {
      label: item.name,
      key: item.id + '-' + parentid + '-' + '0'
    }))
  })
  return tree
}


// -----------------------
// 查询项目权限列表
export function getlistProjectPermission (type) {
  return axiosIns({
    url: `/api/pc/permission/listPermission/${type}`,
    owner: epmcore,
    method: 'get'
  })
}
// 获取项目角色详情
export function getlistProjectPermissionDetail (id) {
  return axiosIns({
    url: `/api/pc/projectRole/getDetail/${id}`,
    owner: epmcore,
    method: 'get'
  })
}

// 删除项目角色
export function removeProjectPermissionById (id) {
  return axiosIns({
    url: `/api/pc/projectContactPerson/removeById/${id}`,
    owner: epmcore,
    method: 'get'
  })
}

export function projectMemberleave (data) {
  return axiosIns({
    url: `/api/pc/projectMember/leave`,
    owner: epmcore,
    method: 'put',
    data
  })
}

export function projectRolepage (params) {
  return axiosIns({
    url: `/api/pc/projectRole/page`,
    owner: epmcore,
    method: 'get',
    params
  })
}

export function getProjectVersionOverviewStatisticsData (date) {
  return axiosIns({
    url: `/api/pc/statistics/getStatisticsProjectVersionOverviewData`,
    method: 'get',
    owner: epmcore,
    params:date
  })
}

export function progressEstimatepage (params) {
  return axiosIns({
    url: `/api/pc/progressEstimate/page`,
    owner: epmcore,
    method: 'get',
    params
  })
}

export function getProgressEstimateYearOptions(projectVersionId){
  return axiosIns({
    url:'/api/pc/progressEstimate/year/options',
    method:'get',
    owner: epmcore,
    params:{
      projectVersionId: projectVersionId
    }
  })
}

export function getProgressEstimateYearMonthOptions(projectVersionId){
  return axiosIns({
    url:'/api/pc/progressEstimate/month/options',
    method:'get',
    owner: epmcore,
    params:{
      projectVersionId: projectVersionId
    }
  })
}

export function getProgressEstimateYearCost(projectVersionId, year){
  return axiosIns({
    url:'/api/pc/progressEstimate/year/cost',
    method:'get',
    owner: epmcore,
    params: {
      projectVersionId: projectVersionId,
      year: year
    },
  })
}

export function getProgressEstimateYearMonthCost(projectVersionId, yearMonth){
  return axiosIns({
    url:'/api/pc/progressEstimate/month/cost',
    method:'get',
    owner: epmcore,
    params: {
      projectVersionId: projectVersionId,
      yearMonth: yearMonth
    },
  })
}




export function formatTree (e, pid) {
  let tree = []
  e.forEach((item) => {
    if (!item.mpttVOList) {
      tree.push({
        label: item.data.name,
        key: item.id,
        rootId: item.rootId,
        companyId: item.data.companyId,
        mpttRootId: item.data.mpttRootId,
        principal: item.data.principal,
        parentId: pid,
        children: []
      })
    } else {
      tree.push({
        label: item.data.name,
        key: item.id,
        rootId: item.rootId,
        companyId: item.data.companyId,
        mpttRootId: item.data.mpttRootId,
        principal: item.data.principal,
        parentId: pid,
        children: formatTree(item.mpttVOList, item.id)
      })
    }
  })
  return tree
}

export function refreshStatisticsProjectVersionOverviewData (date) {
  return axiosIns({
    url: `/api/pc/statistics/refreshStatisticsProjectVersionOverviewData`,
    method: 'get',
    owner: epmcore,
    params:date
  })
}



// WEBPACK FOOTER //
// ./src/views/project-manage/projectMember-manage/projectMemberAPI.js